module.exports = __webpack_public_path__ + "img/products-3@2x.759df8b.jpg";